export const NO_OPTIONS: string = 'No options';
export const PERFORMANCE_BY_SEGMENTS_TREND = 'Performance by segments - Trend';
export const EXPLORE_TRENDS = 'Explore - Trends';
export const PRODUCTS_TRENDS_TOP_5_PRODUCTS = 'Top 5 products';
export const COMPARE_MODEL = 'Compare Models';
export const EXPLORE_SEGMENTS = 'Explore - Segments';
export const VALUE_OTHERS_LOWERCASE = 'others';
